(() => {
  const root = document.querySelector('[data-vel-confirmation]');
  if (!root) return;
  const data = (() => { try { return JSON.parse(localStorage.getItem('veloure_last_reservation_v1')); } catch (_) { return null; } })();
  const params = new URLSearchParams(location.search);
  const id = params.get('rid') || data?.reservation_id || '—';
  root.querySelector('[data-confirmation-id]').textContent = id;
  const summary = root.querySelector('[data-confirmation-summary]');
  if (!data) {
    summary.innerHTML = '<p style="margin:0;text-align:center;color:#6b6471">Votre réservation a bien été enregistrée. Conservez la référence ci-dessus.</p>';
    return;
  }
  const money = cents => new Intl.NumberFormat('fr-FR',{style:'currency',currency:data.cart?.currency||'EUR'}).format((Number(cents)||0)/100);
  const items = (data.cart?.items || []).map(item => `${item.quantity} × ${item.product_title}${item.variant_title && item.variant_title !== 'Default Title' ? ` — ${item.variant_title}` : ''}`).join('<br>');
  summary.innerHTML = `
    <div class="vel-confirmation__row"><span>Sélection</span><strong>${items || 'Velouré'}</strong></div>
    <div class="vel-confirmation__row"><span>Total prévu</span><strong>${money(data.cart?.total_price)}</strong></div>
    <div class="vel-confirmation__row"><span>Paiement effectué</span><strong>0,00 €</strong></div>
    <div class="vel-confirmation__row"><span>E-mail</span><strong>${data.customer?.email || '—'}</strong></div>
    <div class="vel-confirmation__row"><span>Livraison</span><strong>${[data.customer?.postal_code,data.customer?.city,data.customer?.country].filter(Boolean).join(' ')}</strong></div>`;
})();
